import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { KButtonType, KKcgButtonSubType } from 'ng-k-button';
import { KModalService } from 'ng-k-modal';
import { Observable, Subscriber } from 'rxjs';
import { GlobalLoadingService } from 'src/app/services/global-loading.service';
import { NihlDocumentsService } from 'src/app/services/nihl-documents.service';
import { PdfService } from 'src/app/services/pdf.service';
import { SharedService } from 'src/app/services/shared.service';


@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss'],
})
export class DocumentsComponent implements OnInit {
  @Input() claimId: any;
  KButtonType = KButtonType;
  KKcgButtonSubType = KKcgButtonSubType;
  public reportBuilderForm: any;
  public taskList: any;
  public outcomeList: any;
  public medicalRecords: any;
  public openCreateNewReportModalReference: any;
  public isDeleteReportAllowed: boolean = false;
  public allReports: any;
  public reportById: any = [];
  public maxSize = 8;
  public successText!: string;
  public errorText: string = '';
  public displaySuccess: boolean = false;
  public displayError: boolean = false;
  public timeout!: number;
  public currentMode: any = 'add';
  reportId: any;
  tasks: any;
  constructor(
    private nihlDocumentsService: NihlDocumentsService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private loaderService: GlobalLoadingService,
    private pdfService: PdfService,
    private sharedService: SharedService
  ) {}

  ngOnInit(): void {
    this.getRightsByToken();
    this.reportBuilderForm = this.fb.group({
      reportName: [
        '',
        [Validators.required, Validators.pattern(/^[a-zA-Z0-9]/)],
      ],
      tasks: this.fb.array([]),
      medicalRecords: this.fb.array([]),
      outcome: this.fb.array([]),
    });

    this.fetchReports();
  }

  public fetchReports() {
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = this.claimId;
    this.loaderService.startLoadingIndicator('fetchReports');
    this.nihlDocumentsService.fetchReports(requestParam).subscribe(
      (result) => {
        if (result.status === 'Success') {
          this.loaderService.stopLoadingIndicator('fetchReports');
          this.allReports = result.data;
        }
      },
      (err) => {
        this.loaderService.stopLoadingIndicator('fetchReports');
      }
    );
  }

  public getRightsByToken() {
    let getRightsParam = [{ actionObject: 'Report', actionVerb: ['Delete'] }];
    this.sharedService.getRightsByToken(getRightsParam).subscribe(
      (result: any) => {
        result?.forEach((res: any) => {
          if (
            res.statusCode == 200 &&
            res.data.actionObject === 'Report' &&
            res.data.actionVerb === 'Delete'
          ) {
            this.isDeleteReportAllowed = res.data.isAllowed;
          }
        });
      },
      (err: any) => {
        console.log('error', err?.error);
      }
    );
  }

  saveForm() {
    return new Observable((subscriber) => {
      const requestParam: any = {};
      requestParam.claimId = this.claimId;
      if (this.reportId) {
        requestParam.reportId = this.reportId;
      }
      this.loaderService.startLoadingIndicator('saveForm');
      requestParam.name = this.reportBuilderForm.get('reportName').value;
      requestParam.tasks = this.reportBuilderForm.get('tasks').value;
      requestParam.outcome = this.reportBuilderForm.get('outcome').value;
      requestParam.medicalRecords =
        this.reportBuilderForm.get('medicalRecords').value;
      this.nihlDocumentsService.saveReportBuilder(requestParam).subscribe(
        (result) => {
          if (!result.data) {
            result.data = this.reportId;
          }
          this.loaderService.stopLoadingIndicator('saveForm');
          this.successText = result.message;
          this.showMessage('success', 2000);
          setTimeout(() => {
            this.displaySuccess = false;
            this.modalService.dismissAll();
            this.reportId = null;
            this.reportBuilderForm.reset();
            this.fetchReports();
          }, 2010);
          subscriber.next(result);
        },
        (err) => {
          this.loaderService.stopLoadingIndicator('saveForm');
          this.errorText = err.error.data.message;
          this.showMessage('error', 2000);
          setTimeout(() => {
            this.displayError = false;
          }, 2010);
          subscriber.error(err);
        }
      );
    });
  }

  exportReport() {
    this.saveForm().subscribe(({ data: reportId }: any) => {
      let fileName = this.reportBuilderForm.get('reportName').value;
      this.loaderService.startLoadingIndicator('download_file');
      this.pdfService.downloadNihlReport(reportId, fileName).subscribe({
        next: (fileName) => {
          this.loaderService.stopLoadingIndicator('download_file');
          this.successText = fileName + ' downloaded successfully';
          this.showMessage('success', 2000);
          setTimeout(() => {
            this.displaySuccess = false;
          }, 2010);
        },
        error: (err) => {
          this.loaderService.stopLoadingIndicator('download_file');
          console.log(err);
        },
      });
    });
  }

  confirmDeleteReport(report: any) {
    let text = "Delete '" + report.name + "' report? This cannot be undone.";
    if (confirm(text) == true) {
      text = 'You pressed OK!';
      this.deleteReport(report);
    } else {
      text = 'You canceled!';
    }
  }

  deleteReport(report: any) {
    const thisObj = this;
    const requestParam: any = {};
    requestParam.reportId = report._id;
    this.loaderService.startLoadingIndicator('deleteReport');
    this.nihlDocumentsService.deleteReport(requestParam).subscribe(
      (result) => {
        if (result.status === 'Success') {
          this.loaderService.stopLoadingIndicator('deleteReport');
          this.successText = 'Selected report deleted successfully.';
          this.showMessage('success', 2000);
          setTimeout(() => {
            this.displaySuccess = false;
            this.fetchReports();
          }, 2010);
        }
      },
      (err) => {
        this.loaderService.stopLoadingIndicator('deleteReport');
        console.log(err.error);
        this.errorText = err.error.data.message;
        this.showMessage('error', 2000);
      }
    );
  }

  viewReport(report: any, modalTemplate: any) {
    this.openCreateNewReportModal(modalTemplate, 'edit');
    this.reportId = report._id;
    this.reportBuilderForm.controls;
  }

  closeReportBuilderModal() {
    // this.modalService.setIsOpen('createReportModal', false);
    this.modalService.dismissAll();
    this.reportId = null;
    this.reportBuilderForm.reset();
    this.fetchReports();
  }

  saveReportBuilder() {
    if (this.reportBuilderForm.status) {
      this.loaderService.startLoadingIndicator('saveReportBuilder');
      this.saveForm().subscribe({
        next: (result: any) => {
          if (result.status === 'Success') {
            this.loaderService.stopLoadingIndicator('saveReportBuilder');
            if (result.data) {
              this.reportId = result.data;
            }
            this.successText = result.message;
            this.showMessage('success', 2000);
            setTimeout(() => {
              this.displaySuccess = false;
              this.modalService.dismissAll();
              this.reportId = null;
              this.reportBuilderForm.reset();
              this.fetchReports();
            }, 2010);
          }
        },
        error: (err: any) => {
          this.loaderService.stopLoadingIndicator('saveReportBuilder');
          this.errorText = err.error.data.message;
          this.showMessage('error', 2000);
          setTimeout(() => {
            this.displayError = false;
          }, 2010);
        },
      });
    }
  }

  public showMessage(msgType: any, timeout: any) {
    this.displaySuccess = false;
    if (msgType === 'success') {
      this.displaySuccess = true;
    }
    if (msgType === 'error') {
      this.displayError = true;
    }
    if (timeout) {
      this.timeout = timeout;
    }
  }

  public open(content: any) {
    this.openCreateNewReportModalReference = this.modalService
      .open(content, {
        ariaLabelledBy: 'modal-basic-title',
        size: 'sm',
        centered: true,
        scrollable: true,
        windowClass: ' audiometryResult_mdl',
      })
      .result.then(
        (result) => {
          // console.log(this.closeResult)
        },
        (reason) => {
          // console.log(this.closeResult)
        }
      );
  }

  public getReportDetailsById(reportId: any) {
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = this.claimId;
    requestParam.reportId = reportId;
    this.nihlDocumentsService.fetchReports(requestParam).subscribe(
      (result) => {
        if (result.status === 'Success') {
          this.reportById = result.data;
          // console.log(this.reportById)
          this.reportBuilderForm.patchValue({
            reportName: this.reportById.name,
          });
        }
      },
      (err) => {}
    );
  }

  openCreateNewReportModal(template: any, mode: any) {
    const tasksControl = <FormArray>this.reportBuilderForm.controls['tasks'];
    tasksControl.clear();
    const mrRecords = <FormArray>(
      this.reportBuilderForm.controls['medicalRecords']
    );
    mrRecords.clear();
    const outcomeControl = <FormArray>(
      this.reportBuilderForm.controls['outcome']
    );
    outcomeControl.clear();
    this.currentMode = mode;
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = this.claimId;
    // this.modalService.setIsOpen('createNewReportModal',true);
    this.loaderService.startLoadingIndicator('openCreateNewReportModal');
    this.nihlDocumentsService.getReportBuilder(requestParam).subscribe(
      (result) => {
        if (result.status === 'Success') {
          this.loaderService.stopLoadingIndicator('openCreateNewReportModal');
          this.taskList = result.data.tasks;
          this.outcomeList = result.data.outcome;
          this.medicalRecords = result.data.medicalRecords;

          if (mode == 'edit') {
            thisObj.getReportDetailsById(thisObj.reportId);
            if (thisObj.taskList) {
              thisObj.taskList.forEach((data: any, index: any) => {
                const task_formControl = <FormArray>(
                  thisObj.reportBuilderForm.controls.tasks
                );
                // console.log(task_formControl);
                // console.log(data['id'])

                setTimeout(() => {
                  for (let selectedTask of this.reportById?.tasks) {
                    if (data['id'] == selectedTask) {
                      thisObj.addCheckboxToForm(
                        data['id'],
                        true,
                        task_formControl
                      );
                      data['checked'] = true;
                    }
                  }
                }, 200);
              });
            }

            if (thisObj.outcomeList) {
              thisObj.outcomeList.forEach((data: any, index: any) => {
                const outcome_formControl = <FormArray>(
                  thisObj.reportBuilderForm.controls.outcome
                );
                // console.log(task_formControl);
                // console.log(data['id'])

                setTimeout(() => {
                  for (let selectedOutcome of this.reportById?.outcome) {
                    if (data['id'] == selectedOutcome) {
                      thisObj.addCheckboxToForm(
                        data['id'],
                        true,
                        outcome_formControl
                      );
                      data['checked'] = true;
                    }
                  }
                }, 200);
              });
            }

            if (thisObj.medicalRecords) {
              thisObj.medicalRecords.forEach(function (data: any, index: any) {
                const mr_formControl = <FormArray>(
                  thisObj.reportBuilderForm.controls.medicalRecords
                );
                // thisObj.addCheckboxToForm(data['id'], false, mr_formControl);

                setTimeout(() => {
                  for (let selectedMR of thisObj.reportById.medicalRecords) {
                    if (data['id'] == selectedMR) {
                      // console.log(selectedMR);
                      // console.log(data['id'])
                      thisObj.addCheckboxToForm(
                        data['id'],
                        true,
                        mr_formControl
                      );
                      data['checked'] = true;
                    }
                  }
                }, 250);
              });
            }
          }
          this.open(template);
        }
      },
      (err) => {}
    );
  }

  public addCheckboxToForm(id: any, isChecked: any, checkboxControl: any) {
    if (isChecked) {
      // console.log('isChecked')
      checkboxControl.push(new FormControl(id));
    } else {
      // console.log('is not Checked')
      const index = checkboxControl.controls.findIndex(
        (x: { value: any }) => x.value === id
      );
      checkboxControl.removeAt(index);
    }
    // console.log(checkboxControl)
  }

  public onChangeCheckbox(i: any, isChecked: any, control: any, form: any) {
    const id = i.id;
    i.checked = isChecked.target.checked;
    const checkboxControl = <FormArray>form.controls[control];
    this.addCheckboxToForm(id, isChecked.target.checked, checkboxControl);
  }

  showExportBtn() {
    if (
      (
        this.reportBuilderForm.get('medicalRecords').value.length >= 1 
        || this.reportBuilderForm.get('tasks').value.length >= 1
        || this.reportBuilderForm.get('outcome').value.length >= 1
      )
      && this.reportBuilderForm.valid
    ) {
      return true;
    }
    return false;
  }

}
